// React basic
import { useEffect, useState } from 'react'
import { useNavigate, Link, useSearchParams } from "react-router-dom"


// Tailwind
import {
  ChatBubbleLeftRightIcon,
  IdentificationIcon,
  PlayCircleIcon,
  ChartPieIcon,
} from '@heroicons/react/20/solid'
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/react/16/solid'

// Components - utility
import Background from '../components/Background'
import Container from '../components/Container'
import Button from '../components/Button'

// Components - sections
import BestInClass from '../components/BestInClass'
import Investors from '../components/Investors'
import Pilot from '../components/Pilot'
import ValuePropositions from '../components/ValuePropositions'
import PerformanceSecuritySafety from '../components/PerformanceSecuritySafety'


import { LogoTextOnly } from '../components/logo'



// Other libraries
import ReactLoading from 'react-loading'
import axios from 'axios'


// Custom
import { mixpanel_client_track } from "../libs/mixpanelClient"


const IndexPage = ({
  coordinator,
  set_coordinator,

  user_data,
  set_user_data,

  demo_is_active,
  set_demo_is_active,

  set_demo_modal_is_open,

  journey,
} : {
  coordinator : any
  set_coordinator : any

  user_data : any
  set_user_data : any

  demo_is_active : any
  set_demo_is_active : any

  set_demo_modal_is_open : any

  journey : any
}) => {


  // Navigate
  const navigate = useNavigate()

  // Search params
  // const [search_params, _] = useSearchParams()

  // const param_journey = search_params.get("journey")

  // States  
  // const [demo_is_active, set_demo_is_active] = useState(false);
  // const [demo_is_active, set_demo_is_active] = useState(demo_is_active_options[0]);
  // const [demo_is_active, set_demo_is_active] = useState(param_demo_is_active === "true")
  // const [hero_dropdown_is_open, set_hero_dropdown_is_open] = useState(false);

  // Modal
  // const [demo_modal_is_open, set_demo_modal_is_open] = useState(false)
  
  
  
  useEffect(() => {

    // Mixpanel tracking
    mixpanel_client_track("www_index_visited", null)
    
  }, [])

  return (
    <div id="top" className="">
      
      {/* Hero section */}
      <div className="relative isolate overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <Background className="" />
        </div>
        <Container className="relative flex flex-col items-start justify-center min-h-[calc(100vh-8px)] py-32 md:py-0 z-10 pointer-events-none">
          <div id="hero-content" className="flex flex-col items-start text-left w-full max-w-3xl pt-0 pointer-events-auto">
            {/* <div className="mb-4 bg-">
              <LogoTextOnly className="h-8" fill="#ffffff" opacity={0.3} />
            </div> */}
            <div className="mb-3 text-xs lg:text-sm font-base text-gray-400">
              {/* Purpose-built AI for risk adjustment */}
              PURPOSE-BUILT AI FOR RISK ADJUSTMENT
            </div>
            <h1 className="font-display text-4xl lg:text-6xl font-light tracking-tight text-white drop-shadow-lg mb-5 lg:mb-6 space-y-3 lg:space-y-2">
              <span className="block">RAF Precision AI for MAOs</span>
            </h1>
            <p className="text-base lg:text-xl font-light text-white/90 mb-5 lg:mb-10 max-w-xl drop-shadow">
              Boost coding accuracy, uncover hidden prospective signals. increase audit-defensibility of your risk adjustment operations
            </p>
            <div className="flex flex-row items-center gap-0">
              <Button
                to="/demo#top"
                variant="secondary"
                className="rounded-[0px] rounded-none text-sm lg:text-base"
              >
                <span className="font-normal">Book a demo</span>
              </Button>
              <Link
                className="text-white text-base lg:text-lg font-light ml-2 flex items-center rounded-[0px] px-3 lg:px-4 py-2 transition bg-transparent hover:bg-white/10 focus:bg-white/10 active:bg-white/20 focus:outline-none border-none cursor-pointer no-underline"
                tabIndex={0}
                role="button"
                to="#raf-precision-ai"
              >
                See how it works <span className="ml-1">↓</span>
              </Link>
            </div>
          </div>
        </Container>
      </div>

      {/* Post-hero sections */}
      <Investors />
      <BestInClass />
      <Pilot />
      <ValuePropositions />
      <PerformanceSecuritySafety />

    </div>
  )
}



export default IndexPage